export const BASE_PATH = process.env.VUE_APP_BASE_PATH
export const STAR_SHOP_BASE_URL = process.env.VUE_APP_STAR_SHOP_BASE_URL
export const STAR_CARD_REGISTER = 'https://card.paystar.ir/card-register'
export const SHOP_LOGIN = 'http://staging.paystar.shop/'
